import Box from '@mui/material/Box';
import Stack from '@mui/material/Stack';
import Shimmer from './Shimmer';

// Skeleton for the My Tickets list. Mirrors each row card:
//   ticket-id code · truncated message · status pill (right) · meta row
//   (category · date · reply count).
// The header (eyebrow, "My tickets" title, "+ New ticket" button) stays
// visible during load since it doesn't depend on the fetch.

const TicketRowShimmer = ({ hasBadge = false }) => (
  <Box
    sx={{
      bgcolor: '#fff',
      border: '1px solid var(--border-l)',
      borderRadius: '14px',
      p: 2.25,
    }}
  >
    <Stack direction="row" justifyContent="space-between" alignItems="flex-start" spacing={1.5} sx={{ mb: 1 }}>
      <Box sx={{ minWidth: 0, flex: 1 }}>
        <Shimmer width={90} height={10} rounded={4} sx={{ mb: 0.75 }} />
        <Shimmer width="85%" height={13} rounded={4} />
      </Box>
      <Shimmer width={70} height={22} rounded={100} sx={{ flexShrink: 0 }} />
    </Stack>
    <Stack direction="row" spacing={2} flexWrap="wrap" rowGap={0.5}>
      <Shimmer width={70} height={11} rounded={4} />
      <Shimmer width={110} height={11} rounded={4} />
      <Shimmer width={80} height={11} rounded={4} />
      {hasBadge && <Shimmer width={72} height={18} rounded={100} />}
    </Stack>
  </Box>
);

const MyTicketsShimmer = ({ count = 4 }) => (
  <Stack spacing={1.5}>
    {Array.from({ length: count }).map((_, i) => (
      <TicketRowShimmer key={i} hasBadge={i === 0} />
    ))}
  </Stack>
);

export default MyTicketsShimmer;
